import Request from '../helpers/Request';
const PasswordConfirmationRequests = {
    getPasswordPolicy(route, data, resolver) {
        Request.post(this.getPasswordPolicy.name, route, data, resolver);
    }
};
export default PasswordConfirmationRequests;
